import React, { Component } from "react";
import ElectronicPayrollForm from "../ElectronicPayrollForm/ElectronicPayrollForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimePage
Description : Componente que contienen el formulario de la pantalla Overtime
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente OvertimeForm
================================================================================ */
class ElectronicPayrollPage extends Component{
    render(){
        return(
            <div>                    
                <ElectronicPayrollForm/>
            </div>
        )   
    }
}

export default ElectronicPayrollPage;